<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :product-class="productClass"
            @form-submitted="updateCustomerSegments"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Products/ProductClasses/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    productClass: {
        type: Object,
        default: () => { return {} }
    }
})

function updateCustomerSegments (form) {
    form.put(route('products.product-classes.update', {
        product_class: props.productClass.id
    }))
}
</script>
